import * as types from './mutation-types'

export const fetchFunders = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/funders`, {params}).then((response) => {
      commit(types.BOOTSTRAP_FUNDERS, response.data.funders.data)
      commit(types.SET_TOTAL_FUNDERS, response.data.funders.total)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const viewFunder = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    commit(types.VIEW_FUNDER, data)
  })
}

export const fetchViewFunder = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/funders/${id}`).then((response) => {
      commit(types.VIEW_FUNDER, response.data.account)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}


export const setSelectAllState = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_STATE, data)
}

export const selectAllFunders = ({ commit, dispatch, state }) => {
  if (state.selectedFunders.length === state.funders.length) {
    commit(types.SET_SELECTED_FUNDERS, [])
    commit(types.SET_SELECT_ALL_STATE, false)
  } else {
    let allFunderIds = state.funders.map(cust => cust.id)
    commit(types.SET_SELECTED_FUNDERS, allFunderIds)
    commit(types.SET_SELECT_ALL_STATE, true)
  }
}

export const selectFunder = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_FUNDERS, data)
  if (state.selectedFunders.length === state.funders.length) {
    commit(types.SET_SELECT_ALL_STATE, true)
  } else {
    commit(types.SET_SELECT_ALL_STATE, false)
  }
}

export const resetSelectedCustomer = ({ commit, dispatch, state }, data) => {
  commit(types.RESET_SELECTED_FUNDER)
}
export const singleFunderArray = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/funders/${id}/singleFunderRow`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const fetchAllFunders = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/all/funders`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const fetchBuyersForFunder = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/get/buyers`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const fetchSuppliersFromBuyers = ({ commit, dispatch, state }, buyer_customer_id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/get/suppliers/${buyer_customer_id}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
